import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { ArrowRight } from '@outdoor-voices/ui';
import { PureComponent } from 'react';
import cc from 'classcat';
import PropTypes from 'prop-types';
import css from './ExpandCollapser.module.scss';
import Ellipsis from '../icons/Ellipsis';
import Expander from './Expander';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { createElement as _createElement } from "react";

var ExpandCollapser = /*#__PURE__*/function (_PureComponent) {
  _inherits(ExpandCollapser, _PureComponent);

  var _super = _createSuper(ExpandCollapser);

  function ExpandCollapser(props) {
    var _this;

    _classCallCheck(this, ExpandCollapser);

    _this = _super.call(this, props);
    var index = props.index;
    _this.state = {
      index: index
    };
    _this.timeout = {};
    return _this;
  }

  _createClass(ExpandCollapser, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.timeout);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var index = this.state.index;
      var _this$props = this.props,
          alignLeft = _this$props.alignLeft,
          border = _this$props.border,
          sections = _this$props.sections;
      var alignLeftClass = cc(_defineProperty({}, css.alignLeft, alignLeft));
      var borderClass = cc(_defineProperty({}, css.border, border));
      var buttonClass = cc([css.button, alignLeftClass, borderClass]);
      return /*#__PURE__*/_jsx("ul", {
        className: cc([css.root, borderClass]),
        children: sections.map(function (section, sectionIndex) {
          var id = section.id,
              linkUrl = section.linkUrl,
              _onClick = section.onClick,
              title = section.title,
              utilityAction = section.utilityAction;
          var isCurrent = index === sectionIndex;

          if (utilityAction) {
            return /*#__PURE__*/_jsx("li", {
              className: css.wrap,
              children: /*#__PURE__*/_jsxs("button", {
                className: buttonClass,
                onClick: utilityAction,
                type: "button",
                children: [title, /*#__PURE__*/_jsx(Ellipsis, {})]
              })
            }, id);
          }

          if (linkUrl) {
            return /*#__PURE__*/_jsx("li", {
              className: css.wrap,
              children: /*#__PURE__*/_jsxs("a", {
                className: buttonClass,
                href: linkUrl,
                children: [title, /*#__PURE__*/_jsx(ArrowRight, {})]
              })
            }, id);
          }

          return /*#__PURE__*/_createElement(Expander, _objectSpread(_objectSpread({}, section), {}, {
            alignLeft: alignLeft,
            border: border,
            id: id,
            key: id,
            onClick: function onClick() {
              _this2.setState({
                index: isCurrent ? -1 : sectionIndex
              });

              if (!isCurrent && _onClick) {
                _this2.timeout = setTimeout(_onClick, 50);
              }
            },
            open: isCurrent
          }));
        })
      });
    }
  }]);

  return ExpandCollapser;
}(PureComponent);

ExpandCollapser.defaultProps = {
  alignLeft: false,
  border: true,
  index: -1
};
ExpandCollapser.propTypes = {
  alignLeft: PropTypes.bool,
  border: PropTypes.bool,
  index: PropTypes.number,
  sections: PropTypes.arrayOf(PropTypes.shape()).isRequired
};
export default ExpandCollapser;